export default "__VITE_PUBLIC_ASSET__1acfd023__"